import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Outstationcabservicefrompune() {



  const cardData =
  {
    keyword: 'Outstation Cab Services from Pune',
    heading: 'Aaryan Travels: Outstation Cab Services from Pune',
    headingDescription: ' Aaryan Travels offers reliable Outstation Cab Services from Pune for weekend getaways, family trips, pilgrimages, and long-distance corporate travel. Whether you’re planning a visit to Mahabaleshwar, Shirdi, Lonavala, Goa, Kolhapur, Nashik, or Aurangabad, our fleet of hatchbacks, sedans, SUVs, luxury cars, and tempo travellers ensures a smooth and comfortable journey. With professional chauffeurs, customizable itineraries, and transparent fares, we make intercity travel easy and stress-free. Enjoy 24/7 availability, doorstep pickup anywhere in Pune—including Hinjewadi, Kharadi, Viman Nagar, Hadapsar, and Pune Airport—and choose between one-way or round-trip travel plans. For safe and affordable outstation cab rentals from Pune, Aaryan Travels is your trusted travel companion.',

    top: 'Top Places to Visit in Pune Oustation with Aaryan Travels',

"topPlaces": [
  {
    "title": "Mahabaleshwar",
    "description": "Mahabaleshwar is Pune’s most popular hill station getaway, known for its misty valleys, strawberry farms, and scenic viewpoints like Arthur’s Seat and Wilson Point. Visitors enjoy boating at Venna Lake and exploring colonial-era charm in Mapro Garden. Monsoon and winter make the landscape lush and romantic. Horse rides and street snacks add to the charm. Mahabaleshwar is Pune’s favorite outstation escape for families and couples."
  },
  {
    "title": "Lonavala and Khandala",
    "description": "Lonavala and Khandala are twin hill retreats just 65 km from Pune, famous for their lush green ghats, waterfalls, and viewpoints like Tiger Point and Rajmachi. Tourists flock during monsoon for foggy roads and steaming vada pavs. Trekking spots like Lohagad Fort and Bhushi Dam offer adventure and leisure. The route itself is scenic with tunnels and ghats. Lonavala-Khandala are Pune’s ultimate weekend getaways."
  },
  {
    "title": "Lavasa",
    "description": "Lavasa is a planned lake city modeled after Italian architecture, offering colorful waterfront buildings and serene backdrops. Tourists enjoy cycling, jet skiing, and lakeside walks. Foggy mornings and cool winds make it a photographer’s delight. Cafés and resorts provide peaceful stays away from city noise. Lavasa is Pune’s modern outstation retreat for leisure and relaxation."
  },
  {
    "title": "Alibaug",
    "description": "Alibaug is a coastal paradise near Pune, known for its clean beaches like Alibaug Beach, Kashid Beach, and Nagaon. Visitors enjoy water sports, beach shacks, and ferries to Kolaba Fort. Sunset camel rides and coconut water vibes give a true coastal feel. It is also a favorite for villa stays and weekend parties. Alibaug is Pune’s beachside outstation escape."
  },
  {
    "title": "Shirdi",
    "description": "Shirdi is a major pilgrimage town dedicated to Sai Baba, drawing millions of devotees from Pune and across India. The Sai Baba Temple, Dwarkamai, and Chavadi radiate peace and devotion. Prasadalaya meals and aarti ceremonies offer spiritual fulfillment. Nearby attractions like Shani Shingnapur make it a complete spiritual tour. Shirdi is Pune’s most revered outstation pilgrim route."
  },
  {
    "title": "Nashik and Trimbakeshwar",
    "description": "Nashik is famous for its vineyards, temples, and the sacred Godavari river ghats. Wine tours at Sula Vineyards offer scenic experiences, while Panchvati and Ram Kund hold mythological importance. Nearby Trimbakeshwar Jyotirlinga attracts Shiva devotees year-round. Scenic roads and pleasant weather enhance the journey. Nashik is Pune’s spiritual and wine tourism getaway."
  },
  {
    "title": "Panchgani",
    "description": "Panchgani is a peaceful hill town near Mahabaleshwar, known for its vast Table Land plateau and boarding school charm. The panoramic views of Krishna Valley make it ideal for relaxation. Tourists enjoy paragliding, strawberry treats, and colonial bungalows. Cooler temperatures make it perfect throughout the year. Panchgani is Pune’s scenic and calm outstation spot."
  },
  {
    "title": "Goa",
    "description": "Goa is the ultimate beach and nightlife destination for Pune travelers, offering golden sands, parties, forts, and seafood. From Baga and Calangute to Palolem and Agonda, every beach offers a unique flavor. Water sports, casinos, and Portuguese heritage add to its diversity. Road trips from Pune via Amboli Ghats are especially scenic. Goa is Pune’s most exciting long-drive outstation adventure."
  },
  {
    "title": "Matheran",
    "description": "Matheran is Asia’s only vehicle-free hill station, famous for its red-soil pathways, toy train rides, and panoramic viewpoints like Echo Point and Louisa Point. Tourists explore on horseback or on foot amid dense evergreen forests. The cool breeze and colonial charm make it a timeless retreat. Monsoon fog gives it a magical feel. Matheran is Pune’s eco-friendly outstation escape."
  },
  {
    "title": "Bhimashankar",
    "description": "Bhimashankar is one of the 12 Jyotirlinga shrines of Lord Shiva, located deep in the Sahyadri forests. The ancient temple sits amid lush greenery and misty hills. Wildlife lovers also explore the surrounding Bhimashankar Wildlife Sanctuary. Trekking routes make it popular among adventure seekers. Spirituality meets nature here. Bhimashankar is Pune’s divine and nature-filled outstation destination."
  }
],


"services": [
  {
    "name": "Outstation Cab Services from Pune",
    "description": "Our Outstation Cab Services from Pune offer seamless and comfortable travel options for those looking to explore destinations beyond the city. Whether it’s a business trip, family vacation, or a leisure outing, our service provides a wide range of vehicles including sedans, SUVs, and luxury cars, all maintained to the highest standards. With experienced drivers familiar with long-distance routes, real-time GPS tracking, and customer-focused support, your outstation travel is guaranteed to be safe, convenient, and stress-free."
  },
  {
    "name": "Pune Outstation Taxi",
    "description": "Choose our Pune Outstation Taxi service for reliable and affordable transportation to nearby cities and tourist spots. Perfect for both one-way and round trips, our taxis are equipped with modern amenities and driven by professional chauffeurs to ensure your journey is comfortable and timely. We pride ourselves on flexible booking options, 24/7 availability, and transparent pricing to meet all your outstation travel needs."
  },
  {
    "name": "Outstation Travel Cab Pune",
    "description": "Our Outstation Travel Cab service from Pune is designed for travelers who demand safety, punctuality, and comfort on their journeys. Offering a diverse fleet that caters to solo travelers, families, and corporate clients, our cabs come with air conditioning, ample luggage space, and well-trained drivers. Whether you’re traveling for business or leisure, our service ensures a smooth ride with minimal delays and maximum convenience."
  },
  {
    "name": "Intercity Cab Pune",
    "description": "The Intercity Cab Pune service provides efficient transportation between Pune and neighboring cities with options suited for all budgets and preferences. Whether it’s a quick business trip or a weekend getaway, our cabs guarantee prompt pickups, courteous drivers, and well-maintained vehicles. Enjoy the ease of online booking, flexible payment options, and the assurance of a safe, comfortable journey."
  },
  {
    "name": "Affordable Outstation Cabs Pune",
    "description": "Travel far without worrying about your budget with our Affordable Outstation Cabs service from Pune. We offer competitively priced cab options that don’t compromise on quality or comfort. Our fleet includes economy sedans and spacious SUVs, all operated by skilled drivers who prioritize safety and punctuality. Perfect for families, students, and budget-conscious travelers looking for reliable transportation to outstation destinations."
  },
  {
    "name": "Pune to Nearby Cities Cab",
    "description": "Explore nearby cities easily with our Pune to Nearby Cities Cab service. Whether you’re heading to Lonavala, Nashik, or other popular destinations, our cabs offer flexible timing, clean vehicles, and experienced drivers who know the best routes. Choose from one-way or round-trip packages tailored to your itinerary, ensuring a hassle-free and enjoyable travel experience."
  },
  {
    "name": "Best Outstation Cab Pune",
    "description": "Our Best Outstation Cab service from Pune combines luxury, safety, and punctuality to deliver an exceptional travel experience. Featuring a fleet of premium vehicles including sedans, SUVs, and luxury cars, this service is ideal for those seeking top-quality transportation with attentive customer support and transparent pricing. From airport transfers to long-distance tours, we ensure your journey is comfortable and memorable."
  },
  {
    "name": "Long Distance Cab Pune",
    "description": "For travelers embarking on longer journeys, our Long Distance Cab service from Pune offers reliability and comfort across extended routes. With well-maintained vehicles, courteous drivers, and real-time tracking, you can relax knowing that every aspect of your trip is professionally managed. Suitable for corporate travelers, families, and tourists venturing beyond the city limits."
  },
  {
    "name": "Online Outstation Booking Pune",
    "description": "Simplify your travel planning with our Online Outstation Booking platform for Pune cabs. Book your preferred vehicle anytime, anywhere, with instant confirmation, secure payments, and easy cancellation options. Our user-friendly interface and customer support team ensure a smooth booking experience so you can focus on enjoying your trip."
  },
  {
    "name": "Pune to Goa Cab",
    "description": "Experience a scenic and comfortable ride with our Pune to Goa Cab service. Perfect for tourists and holidaymakers, our vehicles are equipped with air conditioning, ample luggage space, and experienced drivers familiar with highway routes. Whether it’s a solo trip or a family vacation, enjoy flexible booking, competitive pricing, and a safe journey to one of India’s most popular beach destinations."
  },
  {
    "name": "Pune to Mumbai Outstation Cab",
    "description": "Our Pune to Mumbai Outstation Cab service offers fast, reliable, and comfortable transportation between these two major cities. Ideal for business travelers and tourists alike, we provide a variety of vehicles including sedans and SUVs, all driven by professional chauffeurs who prioritize your safety and punctuality."
  },
  {
    "name": "Pune Round Trip Cab",
    "description": "Plan your entire journey with our Pune Round Trip Cab service, offering convenience and cost savings for travelers who need transportation to and from their destination. Whether for corporate visits or leisure tours, this service ensures flexible scheduling, professional drivers, and well-maintained vehicles for a seamless experience."
  },
  {
    "name": "SUV Outstation Hire Pune",
    "description": "Travel in style and space with our SUV Outstation Hire service from Pune. Ideal for families, groups, or travelers with extra luggage, our SUVs offer comfort, safety, and premium features for long-distance journeys. All vehicles are regularly serviced and driven by experienced professionals to ensure a smooth and enjoyable trip."
  },
  {
    "name": "Sedan Cab Outstation Pune",
    "description": "Our Sedan Cab Outstation Pune service provides an economical yet comfortable option for travelers who prefer sleek, air-conditioned sedans for their outstation trips. Whether for business or leisure, enjoy a professional experience with well-maintained vehicles and courteous drivers."
  },
  {
    "name": "Pune Weekend Travel Cab",
    "description": "Make your weekends special with our Pune Weekend Travel Cab service, designed to take you on quick getaways to nearby destinations. Whether it's a hill station, a beach resort, or a cultural spot, we offer flexible booking options, reliable vehicles, and experienced drivers to make your weekend travel enjoyable and stress-free."
  }
],
"tableData": [
  ["Outstation Cab Services from Pune", "Pune Outstation Taxi"],
  ["Outstation Travel Cab Pune", "Intercity Cab Pune"],
  ["Affordable Outstation Cabs Pune", "Pune to Nearby Cities Cab"],
  ["Best Outstation Cab Pune", "Long Distance Cab Pune"],
  ["Online Outstation Booking Pune", "Pune to Goa Cab"],
  ["Pune to Mumbai Outstation Cab", "Pune Round Trip Cab"],
  ["SUV Outstation Hire Pune", "Sedan Cab Outstation Pune"],
  ["Pune Weekend Travel Cab", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Outstation Cab Services from Pune",
    "WhyChoosedescription": "Aaryan Travels offers dependable and comfortable outstation cab services from Pune to various destinations."
  },
  {
    "WhyChooseheading": "Timely Pickup from Any Location in Pune",
    "WhyChoosedescription": "Our drivers ensure prompt pickups to start your outstation journey without any delays."
  },
  {
    "WhyChooseheading": "Well-Maintained and Comfortable Vehicles",
    "WhyChoosedescription": "Travel in sanitized, air-conditioned cars designed for long-distance comfort and safety."
  },
  {
    "WhyChooseheading": "Experienced Drivers Skilled in Outstation Routes",
    "WhyChoosedescription": "Our drivers are familiar with various routes from Pune to ensure a smooth and efficient journey."
  },
  {
    "WhyChooseheading": "Transparent and Affordable Pricing",
    "WhyChoosedescription": "Enjoy upfront pricing covering fuel, tolls, and driver allowances with no hidden charges."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Hassle-Free Bookings",
    "WhyChoosedescription": "Our support team is available around the clock to assist with your outstation cab bookings."
  },
  {
    "WhyChooseheading": "Flexible Booking Options for One-Way or Round Trips",
    "WhyChoosedescription": "Choose from one-way rides or round trips based on your travel plans."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles to Suit Your Travel Needs",
    "WhyChoosedescription": "Select from hatchbacks, sedans, SUVs, or tempo travellers depending on your group size and luggage."
  }
]


















  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer outstation cab services from Pune?',
    answer: 'Yes, Aaryan Travels provides reliable and comfortable outstation cab services from Pune to various destinations.',
  },
  {
    question: 'How can I book outstation cab services from Pune with Aaryan Travels?',
    answer: 'You can book your outstation cab through our website, mobile app, or by contacting our 24x7 customer support team.',
  },
  {
    question: 'What types of vehicles are available for outstation cab services from Pune?',
    answer: 'We offer a variety of vehicles including hatchbacks, sedans, SUVs, and premium cars to suit your travel needs.',
  },
  {
    question: 'Are outstation cabs available for one-way and round trips from Pune?',
    answer: 'Yes, Aaryan Travels offers both one-way and round-trip outstation cab services from Pune.',
  },
  {
    question: 'Are the drivers experienced with outstation routes from Pune?',
    answer: 'Absolutely. Our drivers are licensed professionals familiar with various outstation routes originating from Pune.',
  },
  {
    question: 'Can I book hourly or full-day packages for outstation cab travel from Pune?',
    answer: 'Yes, we provide flexible hourly and full-day rental packages to accommodate your travel plans.',
  },
  {
    question: 'What safety and hygiene measures are followed for outstation cab services from Pune?',
    answer: 'All vehicles are sanitized regularly, and our drivers adhere to strict safety protocols to ensure passenger safety.',
  },
  {
    question: 'Is Aaryan Travels outstation cab service from Pune available 24x7?',
    answer: 'Yes, our booking and cab services are available round the clock for outstation travel from Pune.',
  },
  {
    question: 'What payment options are accepted for outstation cab bookings from Pune?',
    answer: 'We accept cash, credit/debit cards, UPI, and popular digital wallets for convenient payments.',
  },
  {
    question: 'Can I customize pickup and drop-off locations for outstation cab bookings from Pune?',
    answer: 'Yes, Aaryan Travels allows you to specify your preferred pickup and drop-off points for outstation trips from Pune.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Anil Deshpande',
    feedback: 'Aaryan Travels provided excellent outstation cab service from Pune. The journey was comfortable and hassle-free.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Shweta Kulkarni',
    feedback: 'Highly recommend Aaryan Travels for outstation cab services from Pune. Professional drivers and great support.',
    rating: 5,
  },
];



















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Outstation Cab Services from Pune",
  "image": "https://aaryantravels.com/assets/images/outstation-cab-pune.jpg", // replace with actual image URL
  "description": "Reliable and affordable outstation cab services from Pune by Aaryan Travels. Book sedans, SUVs, and chauffeur-driven taxis for long-distance travel, weekend trips, and round trips. Online booking available for hassle-free travel.",
  "brand": {
    "@type": "Brand",
    "name": "Aaryan Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",  // example rating, update as needed
    "ratingCount": "4600", // example rating count, update as needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2000",  // example price, adjust as needed
    "availability": "https://schema.org/InStock",
    "url": "https://aaryantravels.com/outstation-cab-services-pune"
  }
};






  return (
    <div>
<Helmet>
  <title>Outstation Cab Services from Pune | Affordable & Reliable Taxi | Aaryan Travels</title>
  <meta
    name="description"
    content="Reliable and affordable outstation cab services from Pune by Aaryan Travels. Book sedans, SUVs, and chauffeur-driven taxis for long-distance travel, weekend trips, and round trips. Online booking available for hassle-free travel."
  />
  <meta
    name="keywords"
    content="Outstation Cab Services from Pune, Pune Outstation Taxi, Outstation Travel Cab Pune, Intercity Cab Pune, Affordable Outstation Cabs Pune, Pune to Nearby Cities Cab, Best Outstation Cab Pune, Long Distance Cab Pune, Online Outstation Booking Pune, Pune to Goa Cab, Pune to Mumbai Outstation Cab, Pune Round Trip Cab, SUV Outstation Hire Pune, Sedan Cab Outstation Pune, Pune Weekend Travel Cab"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/10.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Outstationcabservicefrompune;